<template>
    <!-- Main container -->
    <nav class="level is-mobile">
        <!-- Left side -->
        <div class="level-left">
            <div class="level-item">
                <button
                    :title="$t('creation.image_type_hint')"
                    class="button"
                    @click="$emit('click', { type: 'singleImage' })"
                >
                    <span class="icon">
                        <i class="fas fa-image" />
                    </span>
                </button>
            </div>
            <div class="level-item">
                <button
                    :title="$t('creation.video_type_hint')"
                    class="button"
                    @click="$emit('click', { type: 'video' })"
                >
                    <span class="icon">
                        <i class="fab fa-youtube" />
                    </span>
                </button>
            </div>
            <div class="level-item">
                <button
                    :title="$t('creation.link_type_hint')"
                    class="button"
                    @click="$emit('click', { type: 'url' })"
                >
                    <span class="icon">
                        <i class="fas fa-link" />
                    </span>
                </button>

                <button
                    :title="$t('creation.embed_type_hint')"
                    class="button"
                    @click="$emit('click', { type: 'embed' })"
                >
                    <span class="icon">
                        <i class="fas fa-code" />
                    </span>
                </button>
            </div>
        </div>

        <!-- Right side -->
        <div class="level-right">
            <p class="level-item">
                <a
                    v-t="$t(`Community.publish`)"
                    :class="{ 'is-loading': saving }"
                    class="button is-pink-red"
                    @click="saveObject"
                />
            </p>
        </div>
    </nav>
</template>

<script>
export default {
    props: {
        saving: { type: Boolean, default: false },
    },
    data() {
        return {
            savingChanges: this.saving,
        };
    },
    computed: {
        isSaving() {
            return this.saving;
        },
    },
    methods: {
        saveObject() {
            //console.log(this.savingChanges)
            if (this.isSaving == true) {
                return;
            }
            //this.savingChanges=true
            this.$emit('saveObject');
        },
    },
};
</script>

<style scoped>
button {
    border: unset !important;
}
</style>
